// extracted by mini-css-extract-plugin
export var button = "_cw-4";
export var hasDarkBackground = "_cw-7";
export var hasLightBackground = "_cw-6";
export var iconWrapper = "_cw-0";
export var large = "_cw-2";
export var medium = "_cw-1";
export var small = "_cw-5";
export var xsmall = "_cw-3";